module.exports = __webpack_public_path__ + "media/newstyle/images/medium-shot-excited-woman-with-laptop-mini-1-20a5ab12482e288c09c132a787e0ede1.png";